<template>
  <v-dialog v-model="show" width="500px">
    <v-card>
      <v-card-title>
        <h3>Select a Time Window</h3>
        <v-spacer></v-spacer>
        <v-btn icon @click="show=false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider color="#42a5f5"></v-divider>

      <v-container>
        <v-row justify="center">
          <v-col cols="12">
            <DateSelector
              v-model="date"
              :allowed-dates="allowedDates"
            ></DateSelector>
          </v-col>
          <v-col cols="12" v-if="noZoneFound">
            <v-alert
              type="warning"
              dense
              outlined
              color="orange darken-2"
              icon="mdi-alert-circle-outline"
            >
              Could not find the zone by postcode
              <strong>{{ this.delivery.postcode }}</strong>
              and suburb
              <strong>{{ this.delivery.suburb }}</strong>.
            </v-alert>
          </v-col>
          <v-col cols="12">
            <v-select
              :items="renderedAvailableTimeWindows"
              item-text="display"
              item-value="id"
              return-object
              v-model="newTimeWindow"
              label="Time Window"
            ></v-select>
          </v-col>
          <v-col cols="12" v-if="overridePermission">
            <v-switch
              justify-center
              style="align-items: center; justify-content: center;"
              color="blue"
              v-model="overrideSwitch"
              :label="overrideSwitch ? 'Ignore Cut Off' : 'Enforce Cut Off'"
            ></v-switch>
          </v-col>
          <v-col cols="12" v-if="isAdmin">
            <v-checkbox
                v-model="isBillable"
                label="Billable Reschedule"
              ></v-checkbox>
          </v-col>
        </v-row>
        <v-card-actions class="justify-center">
          <v-btn text color="blue-grey lighten-2" @click="show=false">Cancel</v-btn>
          <v-btn text color="blue darken-1" @click="reschedule">Save</v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
  import axios from 'axios';
  import DateSelector from "../../../util/DateSelector";
  export default {
    name: "DeliveryRescheduleDialog",
    components: {DateSelector},
    props: {
      tracking: String,
      delivery: Object,
      region_id: {
        type: Number,
        default: null
      },
      showProp: Boolean,
      loading: Boolean,
      disabled: Boolean
    },
    data() {
      return {
        date: null,
        newTimeWindow: null,
        overrideSwitch: false,
        availableTimeWindows: [],
        listTimeWindows: [],
        liteDates: [],
        isBillable: true,
      }
    },
    computed: {
      show: {
        get() {
          return this.showProp;
        },
        set(value) {
          if (!value) this.$emit('close');
        }
      },
      renderedAvailableTimeWindows(){
        if (this.setavailableTimeWindows === undefined || this.setavailableTimeWindows === null) return [];
        return this.setavailableTimeWindows;
      },
      overridePermission() {
        if (this.region_id !== null) {
          return this.$store.getters['auth/hasPermissionRegionId']('delivery_violate_cutoffs', this.region_id);
        } else {
          return this.$store.getters['auth/hasPermission']('delivery_violate_cutoffs', this.region_id);
        }
      },
      noZoneFound() {
        const noWindows = !this.renderedAvailableTimeWindows.length;
        let noDates = true;

        if (typeof this.allowedDates === "function") {
          const today = new Date();
          for (let i = 0; i < 30; i++) {
            const d = new Date(today);
            d.setDate(today.getDate() + i);
            const ymd = d.toISOString().split("T")[0];
            if (this.allowedDates(ymd)) {
              noDates = false;
              break;
            }
          }
        }
        return noWindows || noDates;
      },
      isAdmin() {
        return this.$store.getters['auth/hasPermission']('admin');
      }
    },
    asyncComputed: {
      async setavailableTimeWindows(){
        console.log('setavailableTimeWindows')
        if (this.date){
          this.availableTimeWindows = this.listTimeWindows.filter(tw => tw.date === this.date);
        } else {
          this.availableTimeWindows = [];
        }
        return this.availableTimeWindows;
      },
      async timeWindows() {
        if (this.date === null || this.tracking === null) return [];
        else {
          return await axios.get(process.env.API_URL + '/deliveries/' + this.tracking + '/reschedule/timewindows?date=' + this.date)
            .then((response) => {
              if (response.status === 200) {
                if (response.data.length > 0) {
                  this.newTimeWindow = response.data[0];
                } else {
                  this.newTimeWindow = null;
                }
                return response.data;
              } else {
                console.log('No available time window');
                return [];
              }
            })
            .catch(() => {
            })
        }
      }
    },
    methods: {
      reschedule() {
        if (this.newTimeWindow === null) {
          this.$store.commit('displaySnackbar', 'Must choose time window');
          return false;
        }
        this.$store.commit('displayWaitDialog', true);
        this.$emit('changeLoading', true);
        axios.post(process.env.API_URL + '/deliveries/' + this.tracking + '/reschedule', {
          date: this.date,
          time_window: this.newTimeWindow.id,
          ignore_cutoff: this.overrideSwitch,
          billable: this.isBillable,
        })
          .then((response) => {
            this.$store.commit('displaySnackbar', 'Successfully rescheduled delivery');
            this.show = false;
            this.$store.commit('displayWaitDialog', false);
            this.$emit('changeLoading', false);
          })
          .catch((err) => {
            this.$store.commit('displaySnackbar', 'Error: '+(err.response === undefined ? 'Unknown error' : err.response.data.error)) ;
            this.$store.commit('displayWaitDialog', false);
            this.$emit('changeLoading', false);
          });
      },
      getDefaultTimeWindows() {
        if (this.delivery === null) {
          return [];
        }
        axios.get(process.env.API_URL + '/deliveries/optionsadv?client_id=' + this.delivery.client_id + '&postcode=' +
          this.delivery.postcode +'&suburb=' + this.delivery.suburb + '&service_id=' + this.delivery.service_id + '&reschedule=' + true + '&max_options=20')
          .then((response) => {
            console.log('default');
            if (response.status === 200) {
              console.log('Available Time windows found');
              if (response.data.length > 0) {
                this.listTimeWindows =  response.data.map((tw) => {
                  tw.id = tw.timewindow_id;
                  tw.display = 'From ' + tw.time_start + ' - To ' + tw.time_end;
                  return tw;
                });
                this.newTimeWindow = this.listTimeWindows[0];
                this.liteDates = this.listTimeWindows.map((tw) => {return tw.date});
                this.date = this.newTimeWindow.date;
                this.setavailableTimeWindows();
              } else {
                this.newTimeWindow = null;
              }
            } else {
              console.log('No available time window');
            }
          })
          .catch(() => {
          })
      },
      allowedDates(val){
        return this.liteDates.includes(val);
      },
    },
    mounted() {
      this.getDefaultTimeWindows();
    },
    watch: {
      delivery: function () {
        this.getDefaultTimeWindows();
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/Search/DeliveryRescheduleDialog.vue